import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import isURL from 'validator/es/lib/isURL';

export function urlValidator(forceSecure = false): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        // If value is empty we don't check if value is correct.
        // You should use Validator.reuired validator if you want to require field
        if (!control.value) {
            return null;
        }

        if (!isURL(control.value, { allow_underscores: true })) {
            return { invalidUrl: { value: control.value } };
        }

        if (forceSecure && !isURL(control.value, { protocols: ['https'], allow_underscores: true })) {
            return { insecureUrl: { value: control.value } };
        }

        return null;
    };
}
